<template>
  <div class="tab-pane fade show active" role="tabpanel">
    <SettingsManagementComponent
      v-if="company.id"
      :company="company"
      :is_admin="isAdmin"
      :showReferral="false"
    />
  </div>
</template>

<script setup lang="ts">
import SettingsManagementComponent from "@/dashboard/settings_management/SettingsManagementComponent.vue";
import type { Company } from "@/types";

defineProps<{
  company: Company;
  isAdmin: boolean;
}>();
</script>
